import { ItemMessage } from '../../../../../types/ItemMessage';
import { ItemModel } from '../../../models/ItemModel';

type CountableItem = ItemMessage[] | Pick<ItemModel, 'deleted'>[];

export const countActiveItems = (items: CountableItem) => items.filter((item) => !item.deleted).length;
